export default __webpack_public_path__ + "static/media/menu2.6bf9172c.png";